export default "__VITE_ASSET__gGfG7lpZ__"